module.exports = __webpack_public_path__ + "static/media/TermsAndConditions.d05e5879.png";